import { Button } from "@/components/Button/Button";
import { CloseSvg } from "@/components/Icon/Icon";
import { useOrgCredits } from "@/hooks/credits";
import { Scope, usePermissions } from "@/hooks/permissions";
import { selectShownCreditWarning, setShownCreditWarning } from "@/store/slices/orgSlice";
import { RootState, store } from "@/store/store";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export const NoCreditsDialog = () => {
  const { t } = useTranslation();
  const close = () => {
    store.dispatch(setShownCreditWarning(true));
  };
  const { isOutOfCredits, isLoading } = useOrgCredits({});
  const { [Scope.UpdateFinancials]: canPurchaseCredits } = usePermissions();
  const shownCreditWarning = useSelector((state: RootState) => selectShownCreditWarning(state));

  const handleAction = () => {
    if (canPurchaseCredits) {
      window.open("/credits", "_blank");
    }
    close();
  };

  return (
    <Dialog
      open={!isLoading && isOutOfCredits && !shownCreditWarning}
      onClose={close}
      sx={{
        ".MuiPaper-root": {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: {
            xs: "322px",
            sm: "322px",
            md: "480px",
            lg: "600px",
            xl: "600px"
          },
          maxHeight: "600px",
          width: "100%",
          margin: "28px"
        }
      }}
    >
      <Box
        component="div"
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "16px"
        }}
      >
        <IconButton id="alert-dialog-close" onClick={close} sx={{ padding: "0px" }}>
          <CloseSvg color="inherit" />
        </IconButton>
      </Box>
      <Box
        component="div"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          padding: "24px",
          paddingLeft: "32px",
          paddingTop: "0px",
          gap: "32px",
          height: "100%"
        }}
      >
        <img alt="" width="240" height="240" src={"/images/no-credits-remaining.svg"} />
        <Typography
          component="div"
          id="alert-dialog-title"
          variant="h1"
          sx={{
            fontSize: "1.3em",
            textAlign: "center"
          }}
        >
          {t("subscription:title.noCredits")}
        </Typography>
        <Typography component="div" sx={{ width: "100%" }}>
          {canPurchaseCredits ? t("subscription:description.purchaseCredits") : t("subscription:description.noCredits")}
        </Typography>
        <Button
          id="dialog-confirm"
          variant="contained"
          color={"primary"}
          onClick={handleAction}
          sx={{
            marginBottom: "32px"
          }}
        >
          {canPurchaseCredits ? t("subscription:button.purchaseCredits") : t("common:button.ok")}
        </Button>
      </Box>
    </Dialog>
  );
};
